module.exports = __webpack_public_path__ + "img/ic_baby_temp.b46e9bec.png";